<ng-container [ngSwitch]="componentToDisplay">
  <ng-container
    *ngSwitchCase="'initialSync'"
    [ngTemplateOutlet]="initialSyncTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="'syncDashboard'"
    [ngTemplateOutlet]="syncDashboardTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="'syncInProgress'"
    [ngTemplateOutlet]="syncInProgressTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="'syncComplete'"
    [ngTemplateOutlet]="syncCompleteTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="'unfinishedUpsell'"
    [ngTemplateOutlet]="unfinishedUpsellTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="'syncError'"
    [ngTemplateOutlet]="syncErrorTemplate"
  ></ng-container>
</ng-container>

<ng-template #initialSyncTemplate>
  <div class="sync-wrapper">
    <h2>Initial Sync</h2>
    <div class="sync-body">
      <div class="sync-status">
        <h3><b>Current Sync Status:</b> {{ currentSyncStatus.syncStatus }}</h3>
        <mat-spinner
          color="accent"
          mode="indeterminate"
          diameter="64"
        ></mat-spinner>
      </div>
      <span
        >Performing initial sync with server. To ensure success, do not close,
        lock, or turn off you device. Do not move your device large distances
        and do not change networks.
      </span>
    </div>
  </div>
</ng-template>

<ng-template #syncDashboardTemplate>
  <div class="sync-wrapper">
    <h2>Sync Data with System</h2>
    <div class="sync-body">
      <h3><b>Current Sync Status:</b> {{ currentSyncStatus.syncStatus }}</h3>
      <h3>
        <b>Last Sync:</b> {{ currentSyncStatus.lastSynced | date : "short" }}
      </h3>
      <h3>{{ dynamicStatusText }}</h3>
      <div class="buttons">
        <button mat-raised-button (click)="closeDialog()">Cancel</button>
        <button
          [disabled]="!currentConnectionStatus"
          mat-raised-button
          color="accent"
          (click)="triggerSyncToServer()"
        >
          Start Sync
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #syncInProgressTemplate>
  <div class="sync-wrapper">
    <h2>Sync In Progress</h2>
    <div class="sync-body">
      <div class="sync-status">
        <h3><b>Current Sync Status:</b> {{ currentSyncStatus.syncStatus }}</h3>
        <mat-spinner
          color="accent"
          mode="indeterminate"
          diameter="64"
        ></mat-spinner>
      </div>
      <span>{{ dynamicStatusText }}</span>
      <span
        >Syncing your data with the server. To ensure success, do not close,
        lock, or turn off you device. Do not move your device large distances
        and do not change networks.
      </span>
    </div>
  </div>
</ng-template>

<ng-template #syncCompleteTemplate>
  <div class="sync-wrapper">
    <h2>Sync Complete</h2>
    <div class="sync-body">
      <span
        >Your data has been successfully synced with the server. You can
        continue with normal operations.
      </span>
      <div class="buttons">
        <button mat-raised-button (click)="closeDialog()">Close</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #unfinishedUpsellTemplate>
  <div class="sync-wrapper">
    <h2>Unfinished Upsell Found</h2>
    <div class="sync-body">
      <span
        >An unfinished upsell was found in your offline data. All upsells must
        be either completed or cancelled before you can sync your data with the
        server. Complete or cancel the upsell and try again.
      </span>
      <div class="buttons">
        <button mat-raised-button (click)="closeDialog()">Close</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #syncErrorTemplate>
  <div class="sync-wrapper">
    <h2>Sync Error</h2>
    <div class="sync-body">
      <h3>{{ syncErrorMessage }}</h3>

      <span
        >There was an issue while syncing your data with the server. Please
        check your internet connection and try again. If the problem persists,
        contact support.
      </span>

      <div class="buttons">
        <button mat-raised-button (click)="closeDialog()">Close</button>
        <button
          [disabled]="!currentConnectionStatus"
          mat-raised-button
          color="accent"
          (click)="retryFailedSync()"
        >
          Retry Sync
        </button>
      </div>
    </div>
  </div>
</ng-template>
